<div class="l-item">
    Portal Backend Sync is: {{portalApiSyncVersion}}
</div>
<div class="l-item">
    Tenant Backend Version is: {{tenantApiSyncVersion}}
</div>
<div class="l-item">
    Portal NG Frontend Version is: {{"ng-" + portalNgFrontendVersion}}
</div>
